import { FormFields, PageContent } from 'types/App.types';

// MENU ITEMS
export const APPS_MENU_ITEM = 'our apps';
export const ABOUT_MENU_ITEM = 'about us';
export const CONTACT_MENU_ITEM = 'contact us';
export const PRIVACY_MENU_ITEM = 'privacy policy';
export const TERMS_MENU_ITEM = 'terms of use';

// FORM DATA
export const COUNTRY_INFO: Record<string, { flag: string; name: string }> = {
    AF: { flag: '🇦🇫', name: 'Afghanistan' },
    AX: { flag: '🇦🇽', name: 'Åland Islands' },
    AL: { flag: '🇦🇱', name: 'Albania' },
    DZ: { flag: '🇩🇿', name: 'Algeria' },
    AS: { flag: '🇦🇸', name: 'American Samoa' },
    AD: { flag: '🇦🇩', name: 'Andorra' },
    AO: { flag: '🇦🇴', name: 'Angola' },
    AI: { flag: '🇦🇮', name: 'Anguilla' },
    AQ: { flag: '🇦🇶', name: 'Antarctica' },
    AG: { flag: '🇦🇬', name: 'Antigua and Barbuda' },
    AR: { flag: '🇦🇷', name: 'Argentina' },
    AM: { flag: '🇦🇲', name: 'Armenia' },
    AW: { flag: '🇦🇼', name: 'Aruba' },
    AC: { flag: '🇦🇨', name: 'Ascension Island' },
    AU: { flag: '🇦🇺', name: 'Australia' },
    AT: { flag: '🇦🇹', name: 'Austria' },
    AZ: { flag: '🇦🇿', name: 'Azerbaijan' },
    BS: { flag: '🇧🇸', name: 'Bahamas' },
    BH: { flag: '🇧🇭', name: 'Bahrain' },
    BD: { flag: '🇧🇩', name: 'Bangladesh' },
    BB: { flag: '🇧🇧', name: 'Barbados' },
    BY: { flag: '🇧🇾', name: 'Belarus' },
    BE: { flag: '🇧🇪', name: 'Belgium' },
    BZ: { flag: '🇧🇿', name: 'Belize' },
    BJ: { flag: '🇧🇯', name: 'Benin' },
    BM: { flag: '🇧🇲', name: 'Bermuda' },
    BT: { flag: '🇧🇹', name: 'Bhutan' },
    BO: { flag: '🇧🇴', name: 'Bolivia' },
    BA: { flag: '🇧🇦', name: 'Bosnia and Herzegovina' },
    BW: { flag: '🇧🇼', name: 'Botswana' },
    BV: { flag: '🇧🇻', name: 'Bouvet Island' },
    BR: { flag: '🇧🇷', name: 'Brazil' },
    IO: { flag: '🇮🇴', name: 'British Indian Ocean Territory' },
    VG: { flag: '🇻🇬', name: 'British Virgin Islands' },
    BN: { flag: '🇧🇳', name: 'Brunei' },
    BG: { flag: '🇧🇬', name: 'Bulgaria' },
    BF: { flag: '🇧🇫', name: 'Burkina Faso' },
    BI: { flag: '🇧🇮', name: 'Burundi' },
    KH: { flag: '🇰🇭', name: 'Cambodia' },
    CM: { flag: '🇨🇲', name: 'Cameroon' },
    CA: { flag: '🇨🇦', name: 'Canada' },
    IC: { flag: '🇮🇨', name: 'Canary Islands' },
    CV: { flag: '🇨🇻', name: 'Cape Verde' },
    BQ: { flag: '🇧🇶', name: 'Caribbean Netherlands' },
    KY: { flag: '🇰🇾', name: 'Cayman Islands' },
    CF: { flag: '🇨🇫', name: 'Central African Republic' },
    EA: { flag: '🇪🇦', name: 'Ceuta and Melilla' },
    TD: { flag: '🇹🇩', name: 'Chad' },
    CL: { flag: '🇨🇱', name: 'Chile' },
    CN: { flag: '🇨🇳', name: 'China' },
    CX: { flag: '🇨🇽', name: 'Christmas Island' },
    CP: { flag: '🇨🇵', name: 'Clipperton Island' },
    CC: { flag: '🇨🇨', name: 'Cocos (Keeling) Islands' },
    CO: { flag: '🇨🇴', name: 'Colombia' },
    KM: { flag: '🇰🇲', name: 'Comoros' },
    CG: { flag: '🇨🇬', name: 'Congo' },
    CK: { flag: '🇨🇰', name: 'Cook Islands' },
    CR: { flag: '🇨🇷', name: 'Costa Rica' },
    HR: { flag: '🇭🇷', name: 'Croatia' },
    CU: { flag: '🇨🇺', name: 'Cuba' },
    CW: { flag: '🇨🇼', name: 'Curaçao' },
    CY: { flag: '🇨🇾', name: 'Cyprus' },
    CZ: { flag: '🇨🇿', name: 'Czechia' },
    CD: { flag: '🇨🇩', name: 'Democratic Republic of the Congo' },
    DK: { flag: '🇩🇰', name: 'Denmark' },
    DG: { flag: '🇩🇬', name: 'Diego Garcia' },
    DJ: { flag: '🇩🇯', name: 'Djibouti' },
    DM: { flag: '🇩🇲', name: 'Dominica' },
    DO: { flag: '🇩🇴', name: 'Dominican Republic' },
    EC: { flag: '🇪🇨', name: 'Ecuador' },
    EG: { flag: '🇪🇬', name: 'Egypt' },
    SV: { flag: '🇸🇻', name: 'El Salvador' },
    GQ: { flag: '🇬🇶', name: 'Equatorial Guinea' },
    ER: { flag: '🇪🇷', name: 'Eritrea' },
    EE: { flag: '🇪🇪', name: 'Estonia' },
    SZ: { flag: '🇸🇿', name: 'Eswatini' },
    ET: { flag: '🇪🇹', name: 'Ethiopia' },
    EU: { flag: '🇪🇺', name: 'European Union' },
    FK: { flag: '🇫🇰', name: 'Falkland Islands' },
    FO: { flag: '🇫🇴', name: 'Faroe Islands' },
    FM: { flag: '🇫🇲', name: 'Federated States of Micronesia' },
    FJ: { flag: '🇫🇯', name: 'Fiji' },
    FI: { flag: '🇫🇮', name: 'Finland' },
    FR: { flag: '🇫🇷', name: 'France' },
    GF: { flag: '🇬🇫', name: 'French Guiana' },
    PF: { flag: '🇵🇫', name: 'French Polynesia' },
    TF: { flag: '🇹🇫', name: 'French Southern Territories' },
    GA: { flag: '🇬🇦', name: 'Gabon' },
    GM: { flag: '🇬🇲', name: 'Gambia' },
    GE: { flag: '🇬🇪', name: 'Georgia' },
    DE: { flag: '🇩🇪', name: 'Germany' },
    GH: { flag: '🇬🇭', name: 'Ghana' },
    GI: { flag: '🇬🇮', name: 'Gibraltar' },
    GR: { flag: '🇬🇷', name: 'Greece' },
    GL: { flag: '🇬🇱', name: 'Greenland' },
    GD: { flag: '🇬🇩', name: 'Grenada' },
    GP: { flag: '🇬🇵', name: 'Guadeloupe' },
    GU: { flag: '🇬🇺', name: 'Guam' },
    GT: { flag: '🇬🇹', name: 'Guatemala' },
    GG: { flag: '🇬🇬', name: 'Guernsey' },
    GN: { flag: '🇬🇳', name: 'Guinea' },
    GW: { flag: '🇬🇼', name: 'Guinea-Bissau' },
    GY: { flag: '🇬🇾', name: 'Guyana' },
    HT: { flag: '🇭🇹', name: 'Haiti' },
    HM: { flag: '🇭🇲', name: 'Heard Island and McDonald Islands' },
    HN: { flag: '🇭🇳', name: 'Honduras' },
    HK: { flag: '🇭🇰', name: 'Hong Kong' },
    HU: { flag: '🇭🇺', name: 'Hungary' },
    IS: { flag: '🇮🇸', name: 'Iceland' },
    IN: { flag: '🇮🇳', name: 'India' },
    ID: { flag: '🇮🇩', name: 'Indonesia' },
    IR: { flag: '🇮🇷', name: 'Iran' },
    IQ: { flag: '🇮🇶', name: 'Iraq' },
    IE: { flag: '🇮🇪', name: 'Ireland' },
    IM: { flag: '🇮🇲', name: 'Isle of Man' },
    IL: { flag: '🇮🇱', name: 'Israel' },
    IT: { flag: '🇮🇹', name: 'Italy' },
    CI: { flag: '🇨🇮', name: 'Ivory Coast' },
    JM: { flag: '🇯🇲', name: 'Jamaica' },
    JP: { flag: '🇯🇵', name: 'Japan' },
    JE: { flag: '🇯🇪', name: 'Jersey' },
    JO: { flag: '🇯🇴', name: 'Jordan' },
    KZ: { flag: '🇰🇿', name: 'Kazakhstan' },
    KE: { flag: '🇰🇪', name: 'Kenya' },
    KI: { flag: '🇰🇮', name: 'Kiribati' },
    XK: { flag: '🇽🇰', name: 'Kosovo' },
    KW: { flag: '🇰🇼', name: 'Kuwait' },
    KG: { flag: '🇰🇬', name: 'Kyrgyzstan' },
    LA: { flag: '🇱🇦', name: 'Laos' },
    LV: { flag: '🇱🇻', name: 'Latvia' },
    LB: { flag: '🇱🇧', name: 'Lebanon' },
    LS: { flag: '🇱🇸', name: 'Lesotho' },
    LR: { flag: '🇱🇷', name: 'Liberia' },
    LY: { flag: '🇱🇾', name: 'Libya' },
    LI: { flag: '🇱🇮', name: 'Liechtenstein' },
    LT: { flag: '🇱🇹', name: 'Lithuania' },
    LU: { flag: '🇱🇺', name: 'Luxembourg' },
    MO: { flag: '🇲🇴', name: 'Macau' },
    MG: { flag: '🇲🇬', name: 'Madagascar' },
    MW: { flag: '🇲🇼', name: 'Malawi' },
    MY: { flag: '🇲🇾', name: 'Malaysia' },
    MV: { flag: '🇲🇻', name: 'Maldives' },
    ML: { flag: '🇲🇱', name: 'Mali' },
    MT: { flag: '🇲🇹', name: 'Malta' },
    MH: { flag: '🇲🇭', name: 'Marshall Islands' },
    MQ: { flag: '🇲🇶', name: 'Martinique' },
    MR: { flag: '🇲🇷', name: 'Mauritania' },
    MU: { flag: '🇲🇺', name: 'Mauritius' },
    YT: { flag: '🇾🇹', name: 'Mayotte' },
    MX: { flag: '🇲🇽', name: 'Mexico' },
    MD: { flag: '🇲🇩', name: 'Moldova' },
    MC: { flag: '🇲🇨', name: 'Monaco' },
    MN: { flag: '🇲🇳', name: 'Mongolia' },
    ME: { flag: '🇲🇪', name: 'Montenegro' },
    MS: { flag: '🇲🇸', name: 'Montserrat' },
    MA: { flag: '🇲🇦', name: 'Morocco' },
    MZ: { flag: '🇲🇿', name: 'Mozambique' },
    MM: { flag: '🇲🇲', name: 'Myanmar' },
    NA: { flag: '🇳🇦', name: 'Namibia' },
    NR: { flag: '🇳🇷', name: 'Nauru' },
    NP: { flag: '🇳🇵', name: 'Nepal' },
    NL: { flag: '🇳🇱', name: 'Netherlands' },
    NC: { flag: '🇳🇨', name: 'New Caledonia' },
    NZ: { flag: '🇳🇿', name: 'New Zealand' },
    NI: { flag: '🇳🇮', name: 'Nicaragua' },
    NE: { flag: '🇳🇪', name: 'Niger' },
    NG: { flag: '🇳🇬', name: 'Nigeria' },
    NU: { flag: '🇳🇺', name: 'Niue' },
    NF: { flag: '🇳🇫', name: 'Norfolk Island' },
    KP: { flag: '🇰🇵', name: 'North Korea' },
    MK: { flag: '🇲🇰', name: 'North Macedonia' },
    MP: { flag: '🇲🇵', name: 'Northern Mariana Islands' },
    NO: { flag: '🇳🇴', name: 'Norway' },
    OM: { flag: '🇴🇲', name: 'Oman' },
    PK: { flag: '🇵🇰', name: 'Pakistan' },
    PW: { flag: '🇵🇼', name: 'Palau' },
    PS: { flag: '🇵🇸', name: 'Palestine' },
    PA: { flag: '🇵🇦', name: 'Panama' },
    PG: { flag: '🇵🇬', name: 'Papua New Guinea' },
    PY: { flag: '🇵🇾', name: 'Paraguay' },
    PE: { flag: '🇵🇪', name: 'Peru' },
    PH: { flag: '🇵🇭', name: 'Philippines' },
    PN: { flag: '🇵🇳', name: 'Pitcairn Islands' },
    PL: { flag: '🇵🇱', name: 'Poland' },
    PT: { flag: '🇵🇹', name: 'Portugal' },
    PR: { flag: '🇵🇷', name: 'Puerto Rico' },
    QA: { flag: '🇶🇦', name: 'Qatar' },
    RE: { flag: '🇷🇪', name: 'Réunion' },
    RO: { flag: '🇷🇴', name: 'Romania' },
    RU: { flag: '🇷🇺', name: 'Russia' },
    RW: { flag: '🇷🇼', name: 'Rwanda' },
    BL: { flag: '🇧🇱', name: 'Saint Barthélemy' },
    SH: { flag: '🇸🇭', name: 'Saint Helena' },
    KN: { flag: '🇰🇳', name: 'Saint Kitts and Nevis' },
    LC: { flag: '🇱🇨', name: 'Saint Lucia' },
    MF: { flag: '🇲🇫', name: 'Saint Martin' },
    PM: { flag: '🇵🇲', name: 'Saint Pierre and Miquelon' },
    VC: { flag: '🇻🇨', name: 'Saint Vincent and the Grenadines' },
    WS: { flag: '🇼🇸', name: 'Samoa' },
    SM: { flag: '🇸🇲', name: 'San Marino' },
    ST: { flag: '🇸🇹', name: 'Sao Tome and Principe' },
    SA: { flag: '🇸🇦', name: 'Saudi Arabia' },
    SN: { flag: '🇸🇳', name: 'Senegal' },
    RS: { flag: '🇷🇸', name: 'Serbia' },
    SC: { flag: '🇸🇨', name: 'Seychelles' },
    SL: { flag: '🇸🇱', name: 'Sierra Leone' },
    SG: { flag: '🇸🇬', name: 'Singapore' },
    SX: { flag: '🇸🇽', name: 'Sint Maarten' },
    SK: { flag: '🇸🇰', name: 'Slovakia' },
    SI: { flag: '🇸🇮', name: 'Slovenia' },
    SB: { flag: '🇸🇧', name: 'Solomon Islands' },
    SO: { flag: '🇸🇴', name: 'Somalia' },
    ZA: { flag: '🇿🇦', name: 'South Africa' },
    GS: {
        flag: '🇬🇸',
        name: 'South Georgia and the South Sandwich Islands',
    },
    KR: { flag: '🇰🇷', name: 'South Korea' },
    SS: { flag: '🇸🇸', name: 'South Sudan' },
    ES: { flag: '🇪🇸', name: 'Spain' },
    LK: { flag: '🇱🇰', name: 'Sri Lanka' },
    SD: { flag: '🇸🇩', name: 'Sudan' },
    SR: { flag: '🇸🇷', name: 'Suriname' },
    SJ: { flag: '🇸🇯', name: 'Svalbard and Jan Mayen' },
    SE: { flag: '🇸🇪', name: 'Sweden' },
    CH: { flag: '🇨🇭', name: 'Switzerland' },
    SY: { flag: '🇸🇾', name: 'Syria' },
    TW: { flag: '🇹🇼', name: 'Taiwan' },
    TJ: { flag: '🇹🇯', name: 'Tajikistan' },
    TZ: { flag: '🇹🇿', name: 'Tanzania' },
    TH: { flag: '🇹🇭', name: 'Thailand' },
    TL: { flag: '🇹🇱', name: 'Timor-Leste' },
    TG: { flag: '🇹🇬', name: 'Togo' },
    TK: { flag: '🇹🇰', name: 'Tokelau' },
    TO: { flag: '🇹🇴', name: 'Tonga' },
    TT: { flag: '🇹🇹', name: 'Trinidad and Tobago' },
    TA: { flag: '🇹🇦', name: 'Tristan da Cunha' },
    TN: { flag: '🇹🇳', name: 'Tunisia' },
    TR: { flag: '🇹🇷', name: 'Turkey' },
    TM: { flag: '🇹🇲', name: 'Turkmenistan' },
    TC: { flag: '🇹🇨', name: 'Turks and Caicos Islands' },
    TV: { flag: '🇹🇻', name: 'Tuvalu' },
    UG: { flag: '🇺🇬', name: 'Uganda' },
    UA: { flag: '🇺🇦', name: 'Ukraine' },
    AE: { flag: '🇦🇪', name: 'United Arab Emirates' },
    GB: { flag: '🇬🇧', name: 'United Kingdom' },
    UN: { flag: '🇺🇳', name: 'United Nations' },
    US: { flag: '🇺🇸', name: 'United States' },
    UM: { flag: '🇺🇲', name: 'United States Minor Outlying Islands' },
    VI: { flag: '🇻🇮', name: 'United States Virgin Islands' },
    UY: { flag: '🇺🇾', name: 'Uruguay' },
    UZ: { flag: '🇺🇿', name: 'Uzbekistan' },
    VU: { flag: '🇻🇺', name: 'Vanuatu' },
    VA: { flag: '🇻🇦', name: 'Vatican City' },
    VE: { flag: '🇻🇪', name: 'Venezuela' },
    VN: { flag: '🇻🇳', name: 'Vietnam' },
    WF: { flag: '🇼🇫', name: 'Wallis and Futuna' },
    EH: { flag: '🇪🇭', name: 'Western Sahara' },
    YE: { flag: '🇾🇪', name: 'Yemen' },
    ZM: { flag: '🇿🇲', name: 'Zambia' },
    ZW: { flag: '🇿🇼', name: 'Zimbabwe' },
};

export const FORM_FIELDS: FormFields = {
    topic: 'topic',
    name: 'Name',
    email: 'E-mail',
    country: 'Country',
    message: 'Message',
};

// TEXT PAGES
export const COMPANY_DOMAIN = 'villow.studio';

export const COMPANY_SITE_LINK = `https://${COMPANY_DOMAIN}/`;
export const PRIVACY_PAGE_LINK = `${COMPANY_SITE_LINK}privacy`;
export const TERMS_PAGE_LINK = `${COMPANY_SITE_LINK}terms`;

export const COPYRIGHT_EMAIL = `copyright@${COMPANY_DOMAIN}`;
export const PRIVACY_EMAIL = `privacy@${COMPANY_DOMAIN}`;
export const SUPPORT_EMAIL = `support@${COMPANY_DOMAIN}`;

// NOTE: Structure: Title (object key), paragraph - array, line – string or array (if link inside)
export const PRIVACY_POLICY_CONTENT: PageContent = {
    'Privacy Policy': [
        ['Version effective as of February 15, 2021.'],
        [
            [
                'This document defines the policy the Right holder in relation to the processing of personal data of the users of the website ',
                { 'https://villow.studio/': COMPANY_SITE_LINK },
                ' (hereinafter - the Site), mobile applications of the Right holder (hereinafter - the Policy).',
            ],
            'The User agrees to the terms of this Policy when using the Service or submitting their Personal Data to the Right Holder.',
        ],
        [
            'Personal Data - A set of private data and/or non-personally identifiable information about a User.',
            'User - a natural person who uses the Site, has downloaded the Mobile Application on a smartphone, tablet or other device.',
            'Service - Site and Mobile Application.',
            "Mobile Application - the Right Holder's software with all enhancements and additions.",
            'Processing of Personal Data (Processing) - any action (operation) or a set of actions (operations) with Personal Data performed with or without the use of automation tools. Processing includes, but is not limited to: collection, recording, systematization, accumulation, storage, clarification (updating, modification), extraction, use, transfer (distribution, provision, access), depersonalization, blocking, deletion, destruction.',
            'Automated Processing - processing of Personal Data by means of computer technology.',
            'Distribution - actions aimed at disclosure of Personal Data to an indefinite number of persons.',
            'Provision - actions aimed at disclosure of Personal Data to a certain person (circle of persons).',
            'Blocking - temporary termination of processing of Personal Data (unless the processing is necessary for their clarification).',
            'Destruction - actions as a result of which it becomes impossible to restore the content of Personal Data and (or) as a result of which tangible media of Personal Data are destroyed.',
            'Depersonalization - actions, as a result of which it becomes impossible, without the use of additional information, to determine whether Personal Data belongs to a particular User.',
            'Cross-border transfer of Personal Data - transfer of Personal Data to a foreign country, a foreign authority, a foreign individual or a foreign legal entity.',
        ],
    ],
    '1. Principles of Processing': [
        [
            '1.1. Processing of Personal Data is carried out in accordance with the principles:',
            '1.1.1. The lawfulness and fairness of the Processing.',
            '1.1.2. Processing in accordance with specific, predetermined and legitimate purposes.',
            '1.1.3. Avoidance of combining databases containing Personal Data whose Processing is incompatible with each other.',
            '1.1.4. Processing only those Personal Data that meet the purposes of their Processing.',
            '1.1.5. Compliance of the content and scope of Personal Data with the stated purposes of Processing.',
            '1.1.6. Accuracy, sufficiency, relevance and reliability of Personal Data.',
            '1.1.7. Legitimacy of technical measures aimed at Processing.',
            '1.1.8. Reasonableness and expediency of Processing.',
            '1.1.9. Storage of Personal Data in a form that identifies the subject for no longer than the purpose of the Processing, or for the duration of the Consent period.',
            '1.1.10. Destruction or depersonalization of processed Personal Data in cases specified in this Policy.',
        ],
    ],
    '2. Purposes of Processing': [
        [
            '2.1. The Right Holder shall collect and process Personal Data in order:',
            '2.1.1. To improve the operation and technical support of the Service.',
            '2.1.2. To comply with legal requirements.',
            '2.1.3. To communicate with the User when they send inquiries.',
            '2.1.4. To fulfill obligations to the User when they use the Service.',
            '2.1.5. To conduct statistical research.',
        ],
    ],
    '3. List of Personal Data to be collected': [
        [
            '3.1. The Right Holder processes Personal Data, which the User has indicated in the forms of the Site, sent by e-mail specified in the Policy, in the Service, including:',
            '3.1.1. surname, first name, patronymic;',
            '3.1.2. telephone;',
            '3.1.3. e-mail address.',
            '3.2. The Right Holder processes technical information (non-personalized information) if it can be correlated with the User:',
            "3.2.1. About the User's device: type, device model, OS version, Internet service provider.",
            '3.2.2. About the user: Country, region, city.',
            '3.2.3. About using the Mobile Application: events within the application (date, time and number of visits, information about downloaded or viewed materials, language used), application version, version of libraries used, information about failures within the application.',
            "3.2.4. About the events that occurred during the User's interaction with the Site pages.",
        ],
    ],
    '4. Cookies': [
        [
            "4.1. The Site uses minor files that are placed on the User's device (cookies) that allow information about the User's chosen language to be stored.",
            "4.2. Cookies are used to collect non-personally identifiable information about the User in order to personalize the User's display.",
            '4.3. The User has the right to disable cookies at any time using the functionality of their device.',
            '4.4. If the User disables cookies, certain functionality of the Site may become unavailable, including the language for the User will be English only.',
        ],
    ],
    '5. Terms of processing of Personal Data': [
        [
            '5.1. The legal basis for the Processing shall be:',
            '5.1.1. Fulfillment by the Right Holder of its obligations to the User when he/she uses the Service.',
            "5.1.2. User's request.",
            "5.1.3. User's consent.",
            '5.2. The Right Holder carries out Automated Processing.',
            "5.3. The Right Holder does not verify the User's legal capacity.",
        ],
    ],
    '6. Storage of Personal Data and protection measures': [
        [
            '6.1. The Right Holder processes Personal Data during the term of use of the Service.',
            '6.2. The Right Holder takes administrative, technical measures, which are necessary to protect Personal Data.',
        ],
    ],
    '7. Update, destruction, blocking of Personal Data': [
        [
            '7.1. In case of confirmation of the fact of inaccuracy of Personal Data, the Right Holder shall update it.',
            '7.2. The Right Holder destroys Personal Data in the case of:',
            '7.2.1. The presence of a threat to the security of the Service.',
            "7.2.2. Removal of the Mobile Application from the User's device.",
            '7.2.3. Achievement of the goal of Processing or loss of the need to achieve such goals.',
            '7.2.4. Withdrawal of Consent.',
            '7.3. The Right Holder has the right to temporarily discontinue Processing (except if the Processing is necessary to clarify Personal Data).',
        ],
    ],
    '8. Transfer of Personal Data': [
        [
            '8.1. The Right Holder shall not provide Personal Data to third parties without the consent of the User, except for the following case:',
            '8.1.1. Provision is necessary to stop illegal actions of the User.',
            '8.1.2. To protect the legitimate interests of the Right Holder or third parties.',
            '8.1.3. As established by law.',
            "8.1.4. Receiving a binding request from a judicial authority, prosecutor's office, police, investigative body.",
            '8.2. The Right Holder has the right to provide Personal Data to third parties for processing in order to fulfill obligations to the User.',
            '8.3. The Right Holder uses in the Service the analytical platforms specified in Annex No. 1 to the Policy.',
            '8.4. In case of providing Personal Data, the Operator warns the recipients that this data can be used only for the purposes for which it is communicated.',
        ],
    ],
    '9. Cross-border transfer of Personal Data': [
        [
            '9.1. In order to achieve the goals specified in the Policy, the Right Holder may transfer Personal Data to countries other than the country from which it was originally received.',
            "9.2. Prior to cross-border transfer of Personal Data, the Right Holder shall ensure that the foreign country to whose territory Personal Data is transferred provides adequate protection of the User's rights.",
            '9.3. In the case of cross-border transfer of Personal Data, the Right Holder shall protect the data in accordance with the Policy and the law.',
        ],
    ],
    '10. Rights of the User. Requests to the Right Holder': [
        [
            '10.1. The User has the right to submit a request for clarification or correction of his/her Personal Data or the processing of his/her Personal Data, including:',
            '10.1.1. The legal basis for processing.',
            '10.1.2. The purposes and methods of processing used.',
            '10.1.3. The Personal Data processed, related to the User concerned, the source of their receipt.',
            '10.1.4. The terms of processing, including the terms of storage of Personal Data.',
            '10.1.5. The procedure for exercising the rights provided for by the legislation.',
            '10.1.6. The performed or expected cross-border transfer of data.',
            '10.1.7. Persons to whom Personal Data may be disclosed on the basis of an agreement with the Right Holder, or data of a person performing the processing on behalf of the Right Holder, if the processing is or is intended to be assigned to such a person.',
            [
                "10.2. Right Holder's email ",
                { 'copyright@villow.studio': COPYRIGHT_EMAIL },
                ' for submitting a request.',
            ],
            '10.3. The User must specify in the request the information that allows to identify the User.',
        ],
    ],
    '11. Obligations of the Right Holder': [
        [
            "11.1. Within 30 (thirty) days of receipt of the User's request, the Right Holder is obligated to consider the request and send a reply or reasonable refusal.",
            "11.2. At the User's request, the Right Holder clarifies, blocks or deletes the processed Personal Data if it is incomplete, outdated, inaccurate, illegally obtained or unnecessary for the stated purpose of the Processing.",
            '11.3. The Right Holder shall ensure the lawfulness of the Processing. If it is impossible to ensure the legitimacy of Processing, the Right Holder is obliged to destroy or ensure the Destruction of Personal Data within 10 (ten) business days from the date of detection of unlawful Processing.',
        ],
    ],
    '12. Closing Provisions': [
        [
            [
                '12.1. Availability of the text of the Policy for viewing: The Policy is available for viewing at ',
                { 'https://villow.studio/privacy': PRIVACY_PAGE_LINK },
                '.',
            ],
            '12.2. Limitations of the Policy: The Service, the Policy may contain links to other resources that are not managed by the Right Holder. If the User follows the link he/she is redirected to a third party resource. The Right Holder recommends to read the terms of processing of personal data of third-party resources. The Right Holder is not responsible for the content of third-party resources and their policies regarding the processing of personal data.',
            '12.3. Age restrictions: The Service is intended for a wide audience, if the Mobile application contains age restrictions, the User who does not comply with them shall not use the product. The legal representative of the User whose age did not allow the use of the Mobile Application shall have the right to send a request to the Right Holder to delete the Personal Data of the person being represented.',
            [
                '12.4. Amendments: The Right Holder shall be entitled to make amendments to the Policy as necessary. The current edition shall include the date of the last update. The new version of the Policy shall be effective from the moment of its posting in the public domain at: ',
                { 'https://villow.studio/privacy': PRIVACY_PAGE_LINK },
                '.',
            ],
        ],
        [
            ['E-mail address for matters of the Privacy Policy: ', { 'privacy@villow.studio': PRIVACY_EMAIL }],
            ['E-mail address for other matters: ', { 'support@villow.studio': SUPPORT_EMAIL }],
        ],
    ],
    'Annex 1': [
        ['to the Privacy Policy as of February 15, 2021.'],
        ['Version of Annex 1 effective as of February 15, 2021.'],
        [
            'Analytical platforms',
            [
                '1. Yandex.Metrica counter (Privacy Policy: ',
                {
                    'https://yandex.ru/support/metrica/general/confidential-data.html?lang=ru':
                        'https://yandex.ru/support/metrica/general/confidential-data.html?lang=ru',
                },
                ').',
            ],
        ],
    ],
};

export const TERMS_OF_USE_CONTENT: PageContent = {
    'End User License Agreement': [
        ['Version No. 1 dated 30.04.2021.'],
        [
            'In this license agreement (the "Agreement"), capitalized terms mean:',
            [
                "Application - any application that belongs to the Right Holder. The list of Applications is available on the Right Holder's website ",
                { 'https://villow.studio/': COMPANY_SITE_LINK },
                '.',
            ],
            'User - the person who uses the Application.',
            'App Store - Apple Platform (owned by Apple, Inc.), through which the User may access or install the Application on his or her Device.',
            'Device - authorized smartphone, tablet, personal computer or other device that the User uses legally.',
            'Subscription - the amount of rights granted to the User for a fee.',
            'Fee - the price of the Subscription for a certain period.',
            'Card - a bank card, the details of which are specified by the User in the Account for purchases in the App Store.',
            "Account - User's App Store account, which is required to access the functionality of the Application.",
            'Content - text, links, software, audio, graphic or video images, tags, or other materials or information.',
            [
                "Policy - The rules governing the collection, processing and protection of the User's personal data during the use of the Application. Available at: ",
                { 'https://villow.studio/privacy': PRIVACY_PAGE_LINK },
                '.',
            ],
        ],
    ],
    '1. General provisions': [
        [
            '1.1. The Right Holder grants the User a non-exclusive, personal (non-transferable) license to download the Application onto the Device and use it in accordance with the terms of the Agreement.',
            '1.2. By downloading, accessing or using the Application, the User agrees to the terms of the Agreement and the Policy.',
            '1.3. If the User does not agree with any of the terms of the Agreement or the Policy, he shall not download or use the Application.',
            "1.4. By downloading the Application, the User confirms that in accordance with the laws of the country of his/her location the age of the User allows him/her to use the Application under the terms of the Agreement and the Policy. If the User's age does not allow him/her to accept the terms of the Agreement and the Policy, he/she guarantees that the legal representative has read and agrees with the Agreement and the Policy and allows to use the Application.",
        ],
    ],
    '2. Subscription': [
        [
            '2.1. The Right Holder has the right to provide access to the Application or its individual functionality via Subscription.',
            '2.2. The Right Holder is entitled to provide a trial period of the functionality available under the Subscription for the period specified in the Application.',
            '2.3. Subscription period depends on the Subscription Fee paid by the User.',
            '2.4. The Fee is listed in the Application. The Fee does not include possible commissions of payment providers.',
            '2.5. The Right Holder has the right at its own discretion and unilaterally to set discounts on the Fee, to change it, and the fee paid for the Subscription is not subject to change. The Right Holder notifies about changes in the Fee by posting information in the Application.',
            '2.6. If the App Store has returned the payment for the Subscription to the User, the Right Holder shall block access to the functionality under the Subscription.',
            '2.7. Information about the activated Fee and the number of remaining days of use is contained in the Account.',
        ],
    ],
    '3. Payments': [
        [
            '3.1. The Fee selected by the User is debited from the Card when the User confirms the purchase, and then automatically.',
            '3.2. Subscription renewal Fees shall be charged from the Card until the end of the current Subscription period or at the end of the Subscription period, depending on the App Store approach regarding the original Subscription Fee.',
            '3.3. User may manage Subscriptions and disable their automatic renewal by means of the Account.',
            '3.3.1. The User has the right to cancel Subscriptions during the trial period. If the User fails to cancel the Subscription before the end of the trial period within the period set by the App Store, the payment for the Subscription will be charged from the Card.',
            '3.3.2. If the User cancels a Subscription, the cancellation shall be effective after the end of the last day of the Subscription period. If the User has not canceled the Subscription for the next period, the Fee will be charged from the Card.',
            "3.4. User's payment for the Fee shall be processed through the App Store interface.",
            '3.5. If the Card is not attached to the Account, its details are invalid or there are not enough funds to pay for the Subscription, the Right Holder does not provide access to the Subscription.',
            '3.6. No refunds shall be made for the paid but unused Subscription period.',
        ],
    ],
    '4. Restrictions': [
        [
            '4.1. The User shall not:',
            '4.1.1. sell, distribute, sublicense, assign, or provide simultaneous access on multiple Devices, unless expressly permitted in a particular Application by the Right Holder and specified in the App Store.',
            '4.1.2. use the Application in ways not stipulated by the Agreement;',
            '4.1.3. try to evade the technical limitations set by the Application;',
            '4.1.4. use third-party programs or other means to improve/automate the features of the Application;',
            '4.1.5. use the Application for illegal activities;',
            '4.1.6. decompile, disassemble, reverse engineer, or create derivative works from the Application or parts thereof.',
            '4.2. The User can access the Application from Devices with certain characteristics specified in the description of the Application.',
            '4.3. The Application may contain restrictions on the number of available languages.',
            '4.4. The Right Holder may restrict the use of certain features of the Application for all or certain Users.',
            '4.5. The Application or certain functionality may not be available to the User at certain times or in certain territories, including for technical reasons.',
        ],
    ],
    '5. Liability': [
        [
            '5.1. The Application is provided "as is". Right Holder does not guarantee that the Application meets the User\'s expectations, and is be provided continuously, quickly, reliably and error-free.',
            '5.2. The User carries the responsibility for:',
            '5.2.1. relevance, reliability, absence of third-party claims in relation to the provided Content;',
            '5.2.2. compliance with the laws of the country of location when using the Application. The User shall comply with the restrictions on the use of the Application, which are imposed on it by the law of the country of its location.',
            '5.3. Right holder shall not be liable for:',
            '5.3.1. specialized resources and quality of channels of public communication networks, through which the access to the Application is provided, as well as caused by interruptions in the provision of services by contractors;',
            '5.3.2. breakdowns or other malfunctions of the Device, which occurred during the use of the Application;',
            '5.3.3. consequences caused by the loss or disclosure by the User of his data required to access the Application;',
            '5.3.4. errors and/or violations related to the use of the Application and arising because of unlawful actions of third parties;',
            '5.3.5. failures and interruptions in the operation of the Application caused by force majeure. Such circumstances must be confirmed by certificates from the competent authorities not later than ten (10) working days after their commencement;',
            '5.3.6. failures and interruptions in the operation of the Application caused by actions of government authorities, including law enforcement authorities, relating to seizure and/or confiscation, or otherwise preventing access to the servers of contractors hosting the Application;',
            '5.3.7. actions and payment terms set forth in the App Store.',
            '5.4. The liability of the Right Holder shall not exceed the amount of payment transferred by the User.',
        ],
    ],
    '6. Disputes': [
        [
            '6.1. The Parties shall comply with the pre-trial (claim) procedure for dispute resolution.',
            '6.2. The deadline for replying to the claim is 10 (ten) business days from the date of its receipt by the recipient Party.',
            '6.3. If the dispute cannot be resolved through the claim procedure, the dispute shall be referred to court.',
        ],
    ],
    '7. Updates': [
        [
            '7.1. The Right Holder shall not be obliged to provide the User with new versions of the Application.',
            '7.2. The Right Holder shall be entitled to add or remove any features of the Application at its sole discretion with or without prior notice.',
            '7.3. The Right Holder is entitled to send a notice to the User about the need to update the Application due to the availability of a new version or to update the Application automatically.',
            '7.4. The Right Holder is entitled not to support previous versions of the Application when updates or subsequent versions of the Application appear.',
            [
                '7.5. The Right Holder is entitled to update the Agreement at any time. The new version of the Agreement comes into force from the moment of its posting at: ',
                { 'https://villow.studio/terms': TERMS_PAGE_LINK },
                '.',
            ],
            '7.6. The User shall check the Agreement for changes on his/her own.',
            '7.7. The User agrees to the changes in the Agreement if he/she continues to use the Application.',
        ],
    ],
    '8. Final provisions': [
        [
            "8.1. The Right Holder shall process the User's personal data in order to perform the Agreement on the basis of the Policy.",
            '8.2. The Right Holder has the right to send notices to the User under the Agreement using the contact information specified by the User or to place them in the Application.',
            '8.3. The invalidity or unenforceability of one or more provisions of the Agreement, for whatever reasons, shall not affect the validity or enforceability of the remaining provisions of the Agreement.',
            [
                '8.4. The current version of this Agreement is available to the User at: ',
                { 'https://villow.studio/terms': TERMS_PAGE_LINK },
                '.',
            ],
        ],
    ],
};
